import type { ImportQueueItem } from '@lib/import-queue-ui/types/import-queue-item';

import type { TemplateBulkImportQueueItem } from '../types/template-bulk-import-queue-item';
import { mapTemplateStatusToImportStatus } from './map-template-status-to-import-status';

export function templateQueueItemToImportQueueItem(
  item: TemplateBulkImportQueueItem
): ImportQueueItem {
  const navigationId =
    item.status === 'done' && item.dealId ? item.dealId : undefined;
  return {
    clientId: item.clientId,
    fileName: item.file.name,
    relativePath: item.relativePath || item.file.name,
    status: mapTemplateStatusToImportStatus(item.status),
    errorMessage: item.errorMessage,
    navigationId,
  };
}
